import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import {TransitionService} from "@uirouter/angularjs";
import {regNavn} from "../../felles/tjenester/tredjepartsTjenestenavn";

/**
 * Dette direktivet kan sette meta-tagger basert på konfigurasjon i ui-router.
 *
 * Om justerviewport er satt vil direktivet injisere meta-tag som angir justering av viewporten slik at den skaleres til 1 på mobil. Dette gjør at f.eks.
 * sidene for å registrere gruppe får en skalering som gjør at de fyller skjermen.
 */
export function injiserMetaForInjisering() {
    return [regNavn.ng.ui.$transitions, injiserMeta];
}

export function injiserMeta($transitions: TransitionService): IDirective {
    return {
        restrict: 'A',
        scope: {},
        replace: false,
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) {
            // vent på at angular har gjort sitt før vi legger til meta.
            const vedNavigasjon = $transitions.onSuccess({}, trans => {
                const data:any = trans.to().data;
                if (!data) {
                    // Ingen data definert på view.
                    $element.find('meta[name="viewport"]').replaceWith('<meta name="viewport" content="">');
                    return;
                }

                if (data.justerviewport) {
                    $element.find('meta[name="viewport"]').remove(); // fjern ev. eksisterende
                    $element.append('<meta name="viewport" content="initial-scale=1, user-scalable=no">')

                } else if (!data.justerviewport) {
                    // Setter tom viewport content, å fjerne gjør ikke at nettleser oppdaterer viewporten sin
                    $element.find('meta[name="viewport"]').replaceWith('<meta name="viewport" content="">');
                }
            });
            $scope.$on('$destroy', e => vedNavigasjon());
        }
    }
}

